var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3449_1550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.74731 19.7271C1.74731 20.1546 2.09272 20.5 2.52026 20.5H9.42847V11.4179H1.74731V19.7271ZM11.071 20.5H17.9792C18.4067 20.5 18.7521 20.1546 18.7521 19.7271V11.4179H11.071V20.5ZM19.1386 5.62077H15.5734C15.9019 5.10386 16.0951 4.49034 16.0951 3.83333C16.0951 1.99517 14.6 0.5 12.7618 0.5C11.7618 0.5 10.8608 0.944444 10.2497 1.64493C9.63861 0.944444 8.73765 0.5 7.73765 0.5C5.89948 0.5 4.40432 1.99517 4.40432 3.83333C4.40432 4.49034 4.59514 5.10386 4.92605 5.62077H1.36084C0.933301 5.62077 0.587891 5.96618 0.587891 6.39372V9.77536H9.42847V5.62077H11.071V9.77536H19.9116V6.39372C19.9116 5.96618 19.5662 5.62077 19.1386 5.62077ZM9.42847 5.52415H7.73765C6.80528 5.52415 6.04683 4.7657 6.04683 3.83333C6.04683 2.90097 6.80528 2.14251 7.73765 2.14251C8.67002 2.14251 9.42847 2.90097 9.42847 3.83333V5.52415ZM12.7618 5.52415H11.071V3.83333C11.071 2.90097 11.8294 2.14251 12.7618 2.14251C13.6942 2.14251 14.4526 2.90097 14.4526 3.83333C14.4526 4.7657 13.6942 5.52415 12.7618 5.52415Z",
    fill: "url(#paint0_linear_3449_1550)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3449_1550",
    x1: 1.33111,
    y1: 3.83334,
    x2: 20.2194,
    y2: 4.96719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6535E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E33E9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3449_1550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.84d98044cf94f08ac1e6548e28a9dca6.svg";
export { ForwardRef as ReactComponent };